import { useEffect, useState } from 'react';
import { buildInitialProjectSettings } from '../../../../utils/batchProjectUploadUtils';
import { DetectedProject } from '../../../../utils/projectDetection';
import { ExistingProject, ProjectSettingsMap } from '../models/types';

export const useProjectSettings = (
  detectedProjects: DetectedProject[],
  existingProjects: ExistingProject[]
) => {
  const [projectSettings, setProjectSettings] = useState<ProjectSettingsMap>(
    {}
  );

  useEffect(() => {
    if (detectedProjects.length === 0) {
      setProjectSettings({});
      return;
    }
    setProjectSettings(
      buildInitialProjectSettings(detectedProjects, existingProjects)
    );
  }, [detectedProjects, existingProjects]);

  const updateProjectSetting = (
    folderName: string,
    field: keyof ProjectSettingsMap[string],
    value: ProjectSettingsMap[string][keyof ProjectSettingsMap[string]]
  ) => {
    setProjectSettings((prev) => ({
      ...prev,
      [folderName]: {
        ...prev[folderName],
        [field]: value,
      },
    }));
  };

  return {
    projectSettings,
    updateProjectSetting,
    setProjectSettings,
  };
};
